import { outter_post } from 'common/js/axios-helper';
import {MemberChannelRateApi, MemberManApi} from "./constant/UrlMapper";


const host = '8883'



const select = (data) => {
    return outter_post(MemberManApi.Select, data, host);
};

const selectOne = (data) => {
    return outter_post(MemberManApi.SelectOne, data, host);
};

const selectAllParents = (data) => {
    return outter_post(MemberManApi.SelectAllParents, data, host);
};

const updateParent = (data) => {
    return outter_post(MemberManApi.UpdateParent, data, host);
};

const updateMemStatus = (data) => {
    return outter_post(MemberManApi.UpdateMemStatus, data, host);
};

const updateMemLevel = (data) => {
    return outter_post(MemberManApi.UpdateMemLevel, data, host);
};


const unionFounder = (data) => {
    return outter_post(MemberManApi.UnionFounder, data, host);
};
const unionBill = (data) => {
    return outter_post(MemberManApi.UnionBill, data, host);
};

const unionBillStatus = (data) => {
    return outter_post(MemberManApi.UnionBillStatus, data, host);
};

//卡片信息
const getLogList = (data) => {
    return outter_post(MemberManApi.GetLogList, data, '8885');
};
const selectCard = (data) => {
    return outter_post(MemberManApi.SelectCard, data, '8885');
};
const PrivateGetLogList = (data) => {
    return outter_post(MemberManApi.PrivateGetLogList, data, '8885');
};

//机具划拨开关
const posjijuStatus = (data) => {
    return outter_post(MemberManApi.PosJiJuStatus, data, host);
};
const editMemInfoFlag = (data) => {
    return outter_post(MemberManApi.editMemInfoFlag, data, host);
};

const chongzhi = (data) => {
    return outter_post(MemberManApi.ChongZhi, data, host);
};
const studioSwitch = (data) => {
    return outter_post(MemberManApi.StudioSwitch, data, host);
};
const updateProtectTime = (data) => {
    return outter_post(MemberManApi.UpdateProtectTime, data, host);
};
const upspecialDealer = (data) => {
    return outter_post(MemberManApi.UpspecialDealer, data, host);
};
const upDealer = (data) => {
    return outter_post(MemberManApi.UpDealer, data, host);
};
const plGulijin = (data) => {
    return outter_post(MemberManApi.PLGulijin, data, host);
};
const agentgift = (data) => {
    return outter_post(MemberManApi.AgentGift, data, "9000");
};
const getMemInfoByUserId = (data) => {
    return outter_post(MemberManApi.getMemInfoByUserId, data, host);
};

export default {
    select,
    selectAllParents,
    selectOne,
    updateParent,
    updateMemStatus,
    updateMemLevel,
    unionFounder,
    unionBill,
    getMemInfoByUserId,

    unionBillStatus,

    getLogList,
    selectCard,
    PrivateGetLogList,

    posjijuStatus,
    editMemInfoFlag,

    chongzhi,

    updateProtectTime,

    studioSwitch,

    upspecialDealer,
    upDealer,
    plGulijin,

    agentgift,
}



// WEBPACK FOOTER //
// ./src/service/MemberService.js